var exports = {
  "k": "x8b4e8595--d5abe9--container",
  "K": "x8b4e8595--d5abe9--icon",
};

module.exports = exports;
